.root {
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  overflow: auto;
}

.emptyState {
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}

.contentLayout {
  padding-bottom: 56px;
  margin: 0;
  width: 100%;
  padding: 0;
}

.splitter {
  position: relative;
  display: flex;
  flex: 1;
  overflow: auto;
  padding-bottom: 64px;
  padding: 16px;
}

/*
 * Stable content/sidebar layout. Content always lives in `.contentPane` so its
 * subtree (the editor) is never re-parented when the sidebar toggles — toggling
 * the sidebar only adds or removes the `.sidebarPane` sibling. This avoids
 * remounting the editor and the page-blank-on-toggle reload.
 */
.contentRow {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: row;
  min-height: 0;
  overflow: hidden;
}

.contentPane {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  overflow: auto;
  padding: 16px;
}

/*
 * The default-part notice sits above the bottom bar (76px plus the safe area). Otherwise the bar covers the notice
 * and its "Change for this band" action cannot be tapped. `.root` outranks the Snackbar's own `bottom`.
 */
.root .defaultPartNotice {
  bottom: calc(76px + env(safe-area-inset-bottom, 0px) + var(--tuna-spacing-1));
}

/* Phones: the bottom bar is 68px */
@media (max-width: 599.95px) {
  .root .defaultPartNotice {
    bottom: calc(68px + env(safe-area-inset-bottom, 0px) + var(--tuna-spacing-1));
  }
}

/* Phones (GH #1553): no side inset, so chords and lyrics use the full width */
.contentPane--tiny {
  padding-left: 0;
  padding-right: 0;
}

.sidebarPane {
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  min-width: 0;
  overflow: auto;
  padding: 16px;
}

.sidebar {
  flex: 1;
  padding-bottom: 32px;
}

/*
 * Mobile drawer for the notes panel at narrow viewports (<600px).
 * - Safe-area inset for iOS notches and home-indicator.
 * - Scrollable content area; the panel itself can be tall.
 * - Leaves the bottom bar (68px on phones) uncovered, so the set navigation stays in reach.
 */
.mobileDrawer {
  padding: 12px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: var(--tuna-palette-background-paper);
  border-top: 1px solid var(--tuna-palette-divider);
  box-shadow: 0 -4px 16px color-mix(in oklch, var(--tuna-shadow-color) 12%, transparent);
}

/* The persistent drawer (phones only) renders in `.root`, which outranks the drawer's own `bottom: 0` */
.root .mobileDrawer {
  bottom: calc(68px + env(safe-area-inset-bottom, 0px));
}
